import popupCloseIcon from "../../assests/page/popup-close-icon.svg";
import exandIcon from "../../assests/page/chevron-right.svg";
import backIcon from "../../assests/page/chevron-left.svg";
import searchIcon from "../../assests/sideBar/search-icon.svg";
import lidoBanner from "../../assests/overlay/lidoBanner.svg";
import custodyBanner from "../../assests/page/custody-banner.svg";
import verifiedWalletBanner from "../../assests/page/verified-wallet-banner-custom.svg";
import React, { useEffect, useState } from "react";
import { errorToast, successToast } from "../../utils/constants";
import PaymentMethods from "./paymentMethods";
import { useGetSupportedCurrencies } from "../../hooks/currencies";
import Avatar from "react-avatar";
import { ethers } from "ethers";
import ERC20ABI from "../../utils/abis/ERC20.json";
import LIQUIDITYABI from "../../utils/abis/Liquidity.json";
import { ChainConfig } from "../../utils/config";
import {
  Cash,
  contractAddress,
  ERC20,
  Liquidity,
} from "@verified-network/verified-sdk";
import { useAppKit } from "@reown/appkit/react";
import { getUserCustodyBanks } from "../../services/contracts/clientContract";
import useNetworkStore from "../../store/networkStore";
import useUserStore from "../../store/userSlice";
import GeneralPopupBackground from ".";
import PaymentProcess from "./paymentProcess";
import SuccessPopup from "./success";
import { createMeeClient } from "@biconomy/abstractjs";
import { blinkActiveBanks } from "../../utils/helpers/blink";
import { authenticateKYCStatus } from "../../utils/helpers/kyc";
import { handleCustodyTransaction } from "../../utils/helpers/hextrust";
import {
  authenticatePaymentToken,
  getAllVerifiedCashBalances,
} from "../../utils/helpers/utils";
import { useTranslation } from "react-i18next";

const AddFunds = (props) => {
  const { t } = useTranslation();
  const [amount, setAmount] = useState("");
  const [showAllCurrencies, setShowAllCurrencies] = useState(false);
  const [linkedBankIds, setLinkedBankIds] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState(
    props.currencySelected || {
      countryName: "",
      officialName: "",
      flag: null,
      currencySymbol: "",
      currencyName: "",
      officialCurrencySymbol: "",
      isClicked: false,
      balance: 0.0,
      isCrypto: true,
      tokenAddress: "",
    },
  );
  const [newSearchContent, setNewSearchContent] = useState(null);
  const [userCurrencyBalance, setUserCurrencyBalance] = useState(0.0);
  const [showCustomPopup, setShowCustomPopup] = useState(false);
  const [customPopupContent, setCustomPopupContent] = useState(null);
  const [customPopupPosition, setCustomPopupPosition] = useState("");

  const appKitModal = useAppKit();

  const { getSupportedCurrenciesData, getSupportedCurrenciesLoading } =
    useGetSupportedCurrencies(props?.addFundsAction);

  const { chainId, provider, web3, signer, nexusAccount } = useNetworkStore();
  const { userAddress } = useUserStore();

  const {
    verifiedWalletDetails,
    custodyWalletDetails,
    setVerifiedWalletDetails,
  } = props.generalDataProps;

  useEffect(() => {
    (async () => {
      const handleBankList = async () => {
        setBankList(await blinkActiveBanks());
      };

      await handleBankList();
    })();
  }, []);

  useEffect(() => {
    const fetchUsersBankIds = async () => {
      let bankIds = [];
      await getUserCustodyBanks(chainId, userAddress, signer).then(
        async (res) => {
          if (res) {
            if (
              res.length > 0 &&
              res?.find(
                (bnk) =>
                  ethers.utils
                    .parseBytes32String(bnk?.currency)
                    ?.toLowerCase() === "MONEYHUB"?.toLowerCase(),
              )
            ) {
              const userIdRaw = res?.find(
                (bnk) =>
                  ethers.utils
                    .parseBytes32String(bnk?.currency)
                    ?.toLowerCase() === "MONEYHUB"?.toLowerCase(),
              )?.account;
              const userId = ethers.utils.parseBytes32String(userIdRaw);
              bankIds.push({
                id: userId,
                providerType: "moneyhub",
              });
            }

            if (
              res.length > 0 &&
              res?.find(
                (bnk) =>
                  ethers.utils
                    .parseBytes32String(bnk?.currency)
                    ?.toLowerCase() === "BLINK"?.toLowerCase(),
              )
            ) {
              const userIdRaw = (res?.find(
                (bnk) =>
                  ethers.utils
                    .parseBytes32String(bnk?.currency)
                    ?.toLowerCase() === "BLINK"?.toLowerCase(),
              )).account;
              const userId = ethers.utils.parseBytes32String(userIdRaw);
              bankIds.push({
                id: userId,
                providerType: "blink",
              });
            }
          }
        },
      );
      setLinkedBankIds(bankIds);
    };

    if (chainId && userAddress && signer) {
      fetchUsersBankIds();
    }
  }, [chainId, provider, signer, userAddress]);

  const handleAddFundsButtonDisplay = () => {
    const button = document.getElementById("add-funds-popup-button");
    if (
      button &&
      selectedCurrency.currencySymbol?.length > 0 &&
      document.getElementById("add-funds-popup-input").value.length > 0 &&
      Number(document.getElementById("add-funds-popup-input").value) > 0
    ) {
      button.className = "startup-button-active";
    } else if (button) {
      button.className = "startup-button";
    }
  };

  const handleChooseCurrencyButtonDisplay = () => {
    const button = document.getElementById("choose-currency-popup-button");
    if (button && selectedCurrency.isClicked) {
      button.className = "startup-button-active";
    } else if (button) {
      button.className = "startup-button";
    }
  };

  const handleProvideLiquidity = async () => {
    // authenticate kyc
    setCustomPopupPosition("flex-end");
    setCustomPopupContent(<PaymentProcess title={"Checking KYC status"} />);
    setShowCustomPopup(true);
    await authenticateKYCStatus(
      chainId,
      userAddress,
      web3,
      appKitModal,
      props.setPopupContent,
      props.setPopupContentPosition,
      props.setShowPopup,
      props.setCustomLoading,
      props.setFavouriteClicked,
      false,
      setVerifiedWalletDetails,
      verifiedWalletDetails,
      props.generalDataProps,
    ).then(async (res) => {
      if (!res) {
        setCustomPopupPosition("center");
        setCustomPopupContent(null);
        setShowCustomPopup(false);
        errorToast(
          "Oops Something went wrong",
          "Unexpected error. Try again later",
        );
        return;
      }

      const currencyAmountFixed = ethers.utils
        .parseUnits(amount.toString(), selectedCurrency.tokenDecimals)
        .toString();
      if (Number(selectedCurrency.tokenBalance) < Number(currencyAmountFixed)) {
        setCustomPopupPosition("center");
        setCustomPopupContent(null);
        setShowCustomPopup(false);
        errorToast(
          "Insufficient currency balance!",
          "Top up currency and try again.",
        );

        return;
      }
      const liquidityContractAddress = contractAddress[chainId].Liquidity;
      if (
        res &&
        Object.keys(custodyWalletDetails)?.length > 0 &&
        custodyWalletDetails?.custodyId?.length > 0
      ) {
        if (
          custodyWalletDetails?.address &&
          custodyWalletDetails?.chainId > 0 &&
          liquidityContractAddress &&
          web3 &&
          provider
        ) {
          props.setCustomLoading(true);
          //buy liquidity
          if (
            selectedCurrency?.tokenAddress?.toLowerCase() !==
            ethers.constants.AddressZero.toLowerCase()
          ) {
            const tokenContract = new web3.eth.Contract(
              ERC20ABI,
              selectedCurrency.tokenAddress,
            );
            let isApproved = false;
            await tokenContract.methods
              .allowance(userAddress, liquidityContractAddress)
              .call()
              .then((res) => {
                if (Number(res) >= Number(currencyAmountFixed)) {
                  isApproved = true;
                }
              });

            if (!isApproved) {
              const txData = tokenContract.methods
                .approve(liquidityContractAddress, currencyAmountFixed)
                .encodeABI();
              const txNonce = await web3.eth.getTransactionCount(
                custodyWalletDetails?.address,
              );
              await handleCustodyTransaction(
                custodyWalletDetails,
                selectedCurrency.tokenAddress,
                provider,
                "0",
                txData,
                web3.utils.toHex(txNonce),
                "Verified-Network-Approve",
              ).then((cusRes) => {
                if (cusRes?.toLowerCase() === "completed") {
                  isApproved = true;
                  successToast(
                    "Transaction Successful!",
                    "Approved Liquidity Contract Successfully",
                  );
                } else {
                  props.setCustomLoading(false);
                  errorToast(
                    "Oops Something went wrong",
                    "Approve Transactioon Failed",
                  );
                }
              });
            }

            if (isApproved) {
              const liquidityContractWeb3 = new web3.eth.Contract(
                LIQUIDITYABI,
                liquidityContractAddress,
              );
              const txData = liquidityContractWeb3.methods
                .buy(selectedCurrency.tokenAddress, currencyAmountFixed)
                .encodeABI();
              const txNonce = await web3.eth.getTransactionCount(
                custodyWalletDetails?.address,
              );
              await handleCustodyTransaction(
                custodyWalletDetails,
                selectedCurrency.tokenAddress,
                provider,
                "0",
                txData,
                web3.utils.toHex(txNonce),
                "Verified-Network-Buy-Liquidity",
              ).then((cusRes) => {
                if (cusRes?.toLowerCase() === "completed") {
                  successToast(
                    "Transaction Successful!",
                    "Liquidity Provided Successfully",
                    `${ChainConfig[chainId]?.blockExplorerUrls[0]}tx/${res?.response?.hash}`,
                  );

                  console.log(
                    "Liquidity Provided Successfully with hash ",
                    res?.response?.hash,
                  );
                } else {
                  props.setCustomLoading(false);
                  errorToast(
                    "Oops Something went wrong",
                    "Provide Liquidity Failed",
                  );

                  console.error("Provide Liquidity");
                }
              });
            }
          } else {
            //stake

            const txNonce = await web3.eth.getTransactionCount(
              custodyWalletDetails?.address,
            );
            await handleCustodyTransaction(
              custodyWalletDetails,
              liquidityContractAddress,
              provider,
              amount.toString(),
              null,
              web3.utils.toHex(txNonce),
              "Verified-Network-Stake",
            ).then((cusRes) => {
              if (cusRes?.toLowerCase() === "completed") {
                successToast(
                  "Transaction Successful!",
                  "Stake funds successfully",
                );
              } else {
                props.setCustomLoading(false);
                errorToast("Oops Something went wrong", "Stake funds failed");
              }
            });
          }
          props.setCustomLoading(false);
        }
      } else {
        if (
          res &&
          provider &&
          signer &&
          chainId &&
          userAddress &&
          web3 &&
          liquidityContractAddress
        ) {
          //buy liquidity
          if (
            selectedCurrency?.tokenAddress?.toLowerCase() !==
            ethers.constants.AddressZero.toLowerCase()
          ) {
            const tokenContract = new web3.eth.Contract(
              ERC20ABI,
              selectedCurrency.tokenAddress,
            );
            let isApproved = false;
            await tokenContract.methods
              .allowance(userAddress, liquidityContractAddress)
              .call()
              .then((res) => {
                if (Number(res) >= Number(currencyAmountFixed)) {
                  isApproved = true;
                }
              });
            const helpers = {
              setSelectedCurrency,
              setAmount,
              setPopupContent: props.setPopupContent,
              setPopupContentPosition: props.setPopupContentPosition,
              setShowPopup: props.setShowPopup,
              setFavouriteClicked: props.setFavouriteClicked,
              customLoading: props.customLoading,
              setCustomLoading: props.setCustomLoading,
              generalDataProps: props.generalDataProps,
              setCustomPopupPosition: setCustomPopupPosition,
              setCustomPopupContent: setCustomPopupContent,
              setShowCustomPopup: setShowCustomPopup,
            };
            if (!isApproved) {
              const tokenContractVer = new ERC20(
                signer,
                selectedCurrency.tokenAddress,
              );

              const paymentToken = await authenticatePaymentToken(
                chainId,
                userAddress,
                web3,
                verifiedWalletDetails,
                tokenContractVer,
                "approve",
                [liquidityContractAddress, currencyAmountFixed],
                helpers,
                false,
              );

              setCustomPopupPosition("flex-end");
              setCustomPopupContent(
                <PaymentProcess
                  title={"Transaction Processing"}
                  description={"Approving required contracts"}
                />,
              );

              await tokenContractVer
                .approve(
                  liquidityContractAddress,
                  currencyAmountFixed,
                  paymentToken?.address
                    ? {
                        paymentToken: paymentToken?.address,
                        apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                        rpcUrl: ChainConfig[chainId]?.rpcUrls[0],
                      }
                    : {},
                )
                .then((res) => {
                  if (res?.status === 0) {
                    isApproved = true;
                    successToast(
                      "Transaction Successful!",
                      "Approved Liquidity Contract Successfully",
                      `${ChainConfig[chainId]?.blockExplorerUrls[0]}tx/${res?.response?.hash}`,
                    );
                  } else {
                    setCustomPopupPosition("flex-end");
                    setCustomPopupContent(
                      <SuccessPopup
                        setShowPopup={props.setShowPopup}
                        setPopupContent={props.setPopupContent}
                        setPopupContentPosition={props.setPopupContentPosition}
                        isCustom={true}
                        customTextHeader="Transaction Failed!"
                        customTextFooter="Contracts approval failed."
                        setFavouriteClicked={props.setFavouriteClicked}
                        isError={true}
                        setCustomPopupPosition={setCustomPopupPosition}
                        setCustomPopupContent={setCustomPopupContent}
                        setShowCustomPopup={setShowCustomPopup}
                      />,
                    );
                    setShowCustomPopup(true);

                    errorToast("Transaction Failed", "Approval Failed");
                  }
                })
                .catch((err) => {
                  setCustomPopupPosition("flex-end");
                  setCustomPopupContent(
                    <SuccessPopup
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      isCustom={true}
                      customTextHeader="Transaction Failed!"
                      customTextFooter="Something went wrong with contracts approval"
                      setFavouriteClicked={props.setFavouriteClicked}
                      isError={true}
                      setCustomPopupPosition={setCustomPopupPosition}
                      setCustomPopupContent={setCustomPopupContent}
                      setShowCustomPopup={setShowCustomPopup}
                    />,
                  );
                  setShowCustomPopup(true);
                  errorToast(
                    "Oops Something went wrong",
                    "Approve Transaction Failed",
                  );

                  console.error("Approve Transactioon Failed", err);
                });
            }

            if (isApproved) {
              const liquidityContract = new Liquidity(
                signer,
                liquidityContractAddress,
              );

              const paymentToken = await authenticatePaymentToken(
                chainId,
                userAddress,
                web3,
                verifiedWalletDetails,
                liquidityContract,
                "buy",
                [selectedCurrency.tokenAddress, currencyAmountFixed],
                helpers,
                false,
              );

              setCustomPopupPosition("flex-end");
              setCustomPopupContent(
                <PaymentProcess
                  title={"Providing Liquidity"}
                  description={
                    "Sending liquidity token from your account to smart contract"
                  }
                />,
              );
              setShowCustomPopup(true);

              await liquidityContract
                .buy(
                  selectedCurrency.tokenAddress,
                  currencyAmountFixed,
                  paymentToken?.address
                    ? {
                        paymentToken: paymentToken?.address,
                        apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                        rpcUrl: ChainConfig[chainId]?.rpcUrls[0],
                      }
                    : {},
                )
                .then((res) => {
                  if (res?.status === 0) {
                    setCustomPopupPosition("center");
                    setCustomPopupContent(null);
                    setShowCustomPopup(false);
                    successToast(
                      "Transaction Successful!",
                      "Liquidity Provided Successfully",
                      `${ChainConfig[chainId]?.blockExplorerUrls[0]}tx/${res?.response?.hash}`,
                    );
                    console.log(
                      "Liquidity Provided Successfully with hash ",
                      res?.response?.hash,
                    );

                    props.setPopupContent(
                      <SuccessPopup
                        setShowPopup={props.setShowPopup}
                        setPopupContent={props.setPopupContent}
                        setPopupContentPosition={props.setPopupContentPosition}
                        isCustom={true}
                        customTextHeader="Congratulations!"
                        customTextFooter={`You have successfully provided liquidity. You will be assigned a role or issued vitta tokens soon.`}
                        setFavouriteClicked={props.setFavouriteClicked}
                        showButton={true}
                        buttonText={"Provide more liquidity"}
                        buttonFunc={() => {
                          props.setPopupContentPosition("flex-end");
                          props.setPopupContent(
                            <AddFunds
                              setShowPopup={props.setShowPopup}
                              setPopupContent={props.setPopupContent}
                              setPopupContentPosition={
                                props.setPopupContentPosition
                              }
                              customLoading={props.customLoading}
                              setCustomLoading={props.setCustomLoading}
                              generalDataProps={props.generalDataProps}
                              addFundsAction="stake"
                            />,
                          );
                          props.setShowPopup(true);
                        }}
                      />,
                    );
                    props.setPopupContentPosition("flex-end");
                    props.setShowPopup(true);
                  } else {
                    setCustomPopupPosition("flex-end");
                    setCustomPopupContent(
                      <SuccessPopup
                        setShowPopup={props.setShowPopup}
                        setPopupContent={props.setPopupContent}
                        setPopupContentPosition={props.setPopupContentPosition}
                        isCustom={true}
                        customTextHeader="Transaction Failed!"
                        customTextFooter="Provide liquidity failed."
                        setFavouriteClicked={props.setFavouriteClicked}
                        isError={true}
                        setCustomPopupPosition={setCustomPopupPosition}
                        setCustomPopupContent={setCustomPopupContent}
                        setShowCustomPopup={setShowCustomPopup}
                      />,
                    );
                    setShowCustomPopup(true);
                    errorToast(
                      "Transaction Failed.",
                      "Provide liquidity failed",
                    );
                  }
                })
                .catch((err) => {
                  setCustomPopupPosition("flex-end");
                  setCustomPopupContent(
                    <SuccessPopup
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      isCustom={true}
                      customTextHeader="Transaction Failed!"
                      customTextFooter="Something went wrong while providing liquidity"
                      setFavouriteClicked={props.setFavouriteClicked}
                      isError={true}
                      setCustomPopupPosition={setCustomPopupPosition}
                      setCustomPopupContent={setCustomPopupContent}
                      setShowCustomPopup={setShowCustomPopup}
                    />,
                  );
                  setShowCustomPopup(true);
                  errorToast(
                    "Oops Something went wrong",
                    "Unexpected error. Try again later",
                  );

                  console.error("Provide Liquidity Failed", err);
                });
            }
          } else {
            //stake
            if (
              verifiedWalletDetails &&
              Object?.keys(verifiedWalletDetails)?.length > 0 &&
              nexusAccount
            ) {
              try {
                const cashTokens = await getAllVerifiedCashBalances(
                  chainId,
                  web3,
                  userAddress,
                );

                if (!cashTokens || cashTokens?.length === 0) {
                  setCustomPopupPosition("flex-end");
                  setCustomPopupContent(
                    <SuccessPopup
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      isCustom={true}
                      customTextHeader="Transaction Failed!"
                      customTextFooter="Something went wrong"
                      setFavouriteClicked={props.setFavouriteClicked}
                      isError={true}
                      setCustomPopupPosition={setCustomPopupPosition}
                      setCustomPopupContent={setCustomPopupContent}
                      setShowCustomPopup={setShowCustomPopup}
                    />,
                  );
                  setShowCustomPopup?.(true);
                  errorToast(
                    "Unexpected Error",
                    "No valid Cash Token on this network. Change network and try again.",
                  );

                  return;
                }

                const meeClient = await createMeeClient({
                  account: nexusAccount,
                  apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                });

                const transactionInstruction = await nexusAccount.build({
                  type: "default",
                  data: {
                    chainId,
                    calls: [
                      {
                        chainId: chainId,
                        to: liquidityContractAddress,
                        value: currencyAmountFixed,
                        data: "0x",
                      },
                    ],
                  },
                });

                const quote = await meeClient.getQuote({
                  instructions: [transactionInstruction],
                  feeToken: {
                    address: cashTokens[0]?.address,
                    chainId: chainId,
                  },
                });

                if (
                  Number(cashTokens[0]?.balance) === 0 ||
                  Number(quote?.paymentInfo?.tokenAmount) >
                    Number(cashTokens[0]?.balance)
                ) {
                  setCustomPopupPosition("flex-end");
                  setCustomPopupContent(
                    <SuccessPopup
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      isCustom={true}
                      customTextHeader="Transaction Failed!"
                      customTextFooter={`Insufficient ${cashTokens[0]?.name} to pay for transaction`}
                      setFavouriteClicked={props.setFavouriteClicked}
                      isError={true}
                      setCustomPopupPosition={setCustomPopupPosition}
                      setCustomPopupContent={setCustomPopupContent}
                      setShowCustomPopup={setShowCustomPopup}
                      showButton={true}
                      buttonText={`Topup ${cashTokens[0]?.name}`}
                      buttonFunc={() => {
                        const input = document.getElementById(
                          "add-funds-popup-input",
                        );
                        if (input) {
                          input.value = "";
                        }
                        setSelectedCurrency({
                          countryName: "",
                          officialName: "",
                          flag: null,
                          currencySymbol: "",
                          currencyName: "",
                          officialCurrencySymbol: "",
                          isClicked: false,
                          balance: 0.0,
                          isCrypto: true,
                        });
                        setAmount("");

                        props.setPopupContent(null);
                        props.setPopupContentPosition("flex-end");
                        props.setPopupContent(
                          <AddFunds
                            setShowPopup={props.setShowPopup}
                            setPopupContent={props.setPopupContent}
                            setPopupContentPosition={
                              props.setPopupContentPosition
                            }
                            customLoading={props.customLoading}
                            setCustomLoading={props.setCustomLoading}
                            generalDataProps={props.generalDataProps}
                            addFundsAction="add-funds"
                          />,
                        );
                        props.setShowPopup(true);
                      }}
                    />,
                  );
                  setShowCustomPopup?.(true);
                  errorToast(
                    `Insufficient ${cashTokens[0]?.name} balance`,
                    `You need at least: ${quote?.paymentInfo?.tokenAmount}  ${cashTokens[0]?.name} to proceed.`,
                  );
                }

                setCustomPopupPosition("flex-end");
                setCustomPopupContent(
                  <PaymentProcess
                    title={"Staking Funds"}
                    description={
                      "Sending token from your account to smart contract"
                    }
                  />,
                );

                setShowCustomPopup(true);

                const nowInSec = Math.floor(Date.now() / 1000);

                const { hash } = await meeClient.execute({
                  feeToken: {
                    chainId,
                    address: cashTokens[0]?.address,
                  },
                  instructions: [transactionInstruction],

                  upperBoundTimestamp: nowInSec + 299, //highest is 5 minutes???
                });

                const receipt = await meeClient.waitForSupertransactionReceipt({
                  hash,
                });

                if (receipt?.receipts?.length > 1) {
                  //at least 2 receipts
                  const txReceipt =
                    receipt?.receipts[receipt?.receipts?.length - 1];
                  if (txReceipt?.status === "success") {
                    setCustomPopupPosition("center");
                    setCustomPopupContent(null);
                    setShowCustomPopup(false);
                    successToast(
                      "Transaction Successful!",
                      "Stake funds successfully",
                      `${ChainConfig[chainId]?.blockExplorerUrls[0]}tx/${txReceipt?.transactionHash}`,
                    );

                    props.setPopupContent(
                      <SuccessPopup
                        setShowPopup={props.setShowPopup}
                        setPopupContent={props.setPopupContent}
                        setPopupContentPosition={props.setPopupContentPosition}
                        isCustom={true}
                        customTextHeader="Congratulations!"
                        customTextFooter={`You have successfully staked funds. You will be assigned a role or issued tokens soon.`}
                        setFavouriteClicked={props.setFavouriteClicked}
                        showButton={true}
                        buttonText={"Stake more funds"}
                        buttonFunc={() => {
                          props.setPopupContentPosition("flex-end");
                          props.setPopupContent(
                            <AddFunds
                              setShowPopup={props.setShowPopup}
                              setPopupContent={props.setPopupContent}
                              setPopupContentPosition={
                                props.setPopupContentPosition
                              }
                              customLoading={props.customLoading}
                              setCustomLoading={props.setCustomLoading}
                              generalDataProps={props.generalDataProps}
                              addFundsAction="stake"
                            />,
                          );
                          props.setShowPopup(true);
                        }}
                      />,
                    );
                    props.setPopupContentPosition("flex-end");
                    props.setShowPopup(true);
                    return true;
                  } else {
                    setCustomPopupPosition("flex-end");
                    setCustomPopupContent(
                      <SuccessPopup
                        setShowPopup={props.setShowPopup}
                        setPopupContent={props.setPopupContent}
                        setPopupContentPosition={props.setPopupContentPosition}
                        isCustom={true}
                        customTextHeader="Transaction Failed!"
                        customTextFooter="Stake funds failed."
                        setFavouriteClicked={props.setFavouriteClicked}
                        isError={true}
                        setCustomPopupPosition={setCustomPopupPosition}
                        setCustomPopupContent={setCustomPopupContent}
                        setShowCustomPopup={setShowCustomPopup}
                      />,
                    );
                    setShowCustomPopup(true);

                    errorToast("Transation failed", "Stake Funds Failed.");

                    return false;
                  }
                } else {
                  setCustomPopupPosition("flex-end");
                  setCustomPopupContent(
                    <SuccessPopup
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      isCustom={true}
                      customTextHeader="Transaction Failed!"
                      customTextFooter="Stake funds failed."
                      setFavouriteClicked={props.setFavouriteClicked}
                      isError={true}
                      setCustomPopupPosition={setCustomPopupPosition}
                      setCustomPopupContent={setCustomPopupContent}
                      setShowCustomPopup={setShowCustomPopup}
                    />,
                  );
                  setShowCustomPopup(true);

                  errorToast("Transation failed", "Stake Funds Failed.");

                  console.error(
                    "MEE client transaction failed with error: ",
                    "Receipts lesser than one.",
                  );

                  return false;
                }
              } catch (err) {
                setCustomPopupPosition("flex-end");
                setCustomPopupContent(
                  <SuccessPopup
                    setShowPopup={props.setShowPopup}
                    setPopupContent={props.setPopupContent}
                    setPopupContentPosition={props.setPopupContentPosition}
                    isCustom={true}
                    customTextHeader="Transaction Failed!"
                    customTextFooter="Something went wrong while staking funds"
                    setFavouriteClicked={props.setFavouriteClicked}
                    isError={true}
                    setCustomPopupPosition={setCustomPopupPosition}
                    setCustomPopupContent={setCustomPopupContent}
                    setShowCustomPopup={setShowCustomPopup}
                  />,
                );
                setShowCustomPopup(true);
                errorToast(
                  "Oops Something went wrong",
                  "Unexpected error. Try again later",
                );
                console.error("Stake funds failed", err);

                return false;
              }
            } else {
              setCustomPopupPosition("flex-end");
              setCustomPopupContent(
                <PaymentProcess
                  title={"Staking Funds"}
                  description={
                    "Sending token from your account to smart contract"
                  }
                />,
              );

              setShowCustomPopup(true);

              const transactionObject = {
                from: userAddress,
                to: liquidityContractAddress,
                value: currencyAmountFixed,
              };
              try {
                const transaction = await provider
                  .getSigner(userAddress)
                  .sendTransaction(transactionObject);
                let pendingTransaction = await transaction.wait();
                if (pendingTransaction?.transactionHash) {
                  setCustomPopupPosition("center");
                  setCustomPopupContent(null);
                  setShowCustomPopup(false);
                  successToast(
                    "Transaction Successful!",
                    "Stake funds successfully",
                    `${ChainConfig[chainId]?.blockExplorerUrls[0]}tx/${pendingTransaction?.transactionHash}`,
                  );

                  props.setPopupContent(
                    <SuccessPopup
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      isCustom={true}
                      customTextHeader="Congratulations!"
                      customTextFooter={`You have successfully staked funds. You will be assigned a role or issued tokens soon.`}
                      setFavouriteClicked={props.setFavouriteClicked}
                      showButton={true}
                      buttonText={"Stake more funds"}
                      buttonFunc={() => {
                        props.setPopupContentPosition("flex-end");
                        props.setPopupContent(
                          <AddFunds
                            setShowPopup={props.setShowPopup}
                            setPopupContent={props.setPopupContent}
                            setPopupContentPosition={
                              props.setPopupContentPosition
                            }
                            customLoading={props.customLoading}
                            setCustomLoading={props.setCustomLoading}
                            generalDataProps={props.generalDataProps}
                            addFundsAction="stake"
                          />,
                        );
                        props.setShowPopup(true);
                      }}
                    />,
                  );
                  props.setPopupContentPosition("flex-end");
                  props.setShowPopup(true);
                } else {
                  setCustomPopupPosition("flex-end");
                  setCustomPopupContent(
                    <SuccessPopup
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      isCustom={true}
                      customTextHeader="Transaction Failed!"
                      customTextFooter="Stake funds failed."
                      setFavouriteClicked={props.setFavouriteClicked}
                      isError={true}
                      setCustomPopupPosition={setCustomPopupPosition}
                      setCustomPopupContent={setCustomPopupContent}
                      setShowCustomPopup={setShowCustomPopup}
                    />,
                  );
                  setShowCustomPopup(true);

                  errorToast("Transation failed", "Stake Funds Failed.");
                }
              } catch (err) {
                setCustomPopupPosition("flex-end");
                setCustomPopupContent(
                  <SuccessPopup
                    setShowPopup={props.setShowPopup}
                    setPopupContent={props.setPopupContent}
                    setPopupContentPosition={props.setPopupContentPosition}
                    isCustom={true}
                    customTextHeader="Transaction Failed!"
                    customTextFooter="Something went wrong while staking funds"
                    setFavouriteClicked={props.setFavouriteClicked}
                    isError={true}
                    setCustomPopupPosition={setCustomPopupPosition}
                    setCustomPopupContent={setCustomPopupContent}
                    setShowCustomPopup={setShowCustomPopup}
                  />,
                );
                setShowCustomPopup(true);
                errorToast(
                  "Oops Something went wrong",
                  "Unexpected error. Try again later",
                );

                console.error("Stake funds failed", err);
              }
            }
          }
        } else {
          setCustomPopupPosition("center");
          setCustomPopupContent(null);
          setShowCustomPopup(false);
          errorToast(
            "Oops Something went wrong",
            "Unexpected error. Try again later",
          );
        }
      }
    });
  };

  // console.log("list: ", bankList);

  return (
    <React.Fragment>
      {showCustomPopup && (
        <GeneralPopupBackground
          popupContent={customPopupContent}
          popupContentPosition={
            customPopupPosition !== "" ? customPopupPosition : "center"
          }
        />
      )}
      <div className="add-funds-popup">
        {!showAllCurrencies && (
          <div className="add-funds-content">
            <div className="add-funds-content-header">
              <div className="add-funds-content-header-text-container">
                {props?.addFundsAction === "add-funds" ? (
                  <p className="add-funds-content-header-text">
                    {t("header.addFunds")}
                  </p>
                ) : props?.addFundsAction === "add-funds-others" ? (
                  <p className="add-funds-content-header-text">
                    {t("header.addFunds")}
                  </p>
                ) : props?.addFundsAction === "add-funds-crypto" ? (
                  <p className="add-funds-content-header-text">
                    Issue Verified Cash
                  </p>
                ) : (
                  <p className="add-funds-content-header-text">
                    {" "}
                    {t("header.stakeFunds")}
                  </p>
                )}
              </div>
              <img
                onClick={() => {
                  props.setShowPopup(false);
                  props.setPopupContent(null);
                  setNewSearchContent(null);
                  props.setPopupContentPosition("center");
                  if (props.setFavouriteClicked) {
                    props.setFavouriteClicked(false);
                  }
                }}
                className="add-funds-popup-close-icon"
                alt="Close Icon"
                src={popupCloseIcon}
              />
            </div>
            <div className="add-funds-content-footer">
              <div className="add-funds-content-footer-balance-container">
                <p className="add-funds-content-footer-balance-first">
                  {props?.addFundsAction === "add-funds-others"
                    ? "Account Details:"
                    : "Wallet Balance:"}
                </p>
                {props?.addFundsAction !== "add-funds-others" &&
                  props?.addFundsAction !== "add-funds-crypto" && (
                    <p className="add-funds-content-footer-balance-second">
                      {`${selectedCurrency.officialCurrencySymbol}  ${
                        Number(userCurrencyBalance) > 0
                          ? userCurrencyBalance
                          : Number(selectedCurrency.balance).toFixed(6)
                      }`}
                    </p>
                  )}
                {props?.addFundsAction === "add-funds-others" && (
                  <p className="add-funds-content-footer-balance-second">
                    {props.accountNumber} ({props?.accountBalance}{" "}
                    {props?.accountCurrency})
                  </p>
                )}

                {props?.addFundsAction === "add-funds-crypto" && (
                  <p className="add-funds-content-footer-balance-second">
                    {props?.accountBalance} {props?.accountCurrency}
                  </p>
                )}
              </div>
              <div
                style={{ marginBottom: "12px" }}
                className="asset-info-popup-second-trading-body-line"
              ></div>
              <p className="add-funds-content-footer-text">
                {t("withdrawFunds.enterAmount")}
              </p>
              <div className="a-f-content-footer-input-container">
                <div className="a-f-content-footer-input-group">
                  <p className="a-f-content-footer-input-text">
                    {selectedCurrency.officialCurrencySymbol}
                  </p>
                  <input
                    id="add-funds-popup-input"
                    onInput={(e) => {
                      setAmount(e.target.value);
                      handleAddFundsButtonDisplay();
                    }}
                    type="number"
                    className="a-f-content-footer-input"
                    placeholder="00.00"
                  />
                </div>
                <div
                  onClick={() => {
                    if (
                      props?.addFundsAction !== "add-funds-others" &&
                      props?.addFundsAction !== "add-funds-crypto"
                    ) {
                      setShowAllCurrencies(true);
                    }
                  }}
                  className="a-f-content-footer-currencies"
                >
                  <div className="a-f-content-footer-currencies-container">
                    {props?.addFundsAction !== "add-funds-others" &&
                      props?.addFundsAction !== "add-funds-crypto" && (
                        <p className="a-f-content-footer-currency">
                          {selectedCurrency.currencySymbol}
                        </p>
                      )}

                    {props?.addFundsAction === "add-funds-others" && (
                      <p className="a-f-content-footer-currency">
                        {props.accountCurrency}
                      </p>
                    )}

                    {props?.addFundsAction === "add-funds-crypto" && (
                      <p className="a-f-content-footer-currency">
                        {props.accountCurrency}
                      </p>
                    )}

                    {props?.addFundsAction !== "add-funds-others" &&
                      props?.addFundsAction !== "add-funds-crypto" && (
                        <img alt="Exand Icon" src={exandIcon} />
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {showAllCurrencies && (
          <div
            style={{ overflow: "auto", marginBottom: "30px" }}
            className="add-funds-content"
          >
            <div className="add-funds-content-header">
              <div className="add-funds-content-header-text-container">
                <img
                  onClick={() => {
                    setShowAllCurrencies(false);
                    setNewSearchContent(null);
                  }}
                  className="add-funds-popup-back-icon"
                  alt="Back Icon"
                  src={backIcon}
                />
                <p className="add-funds-search-header-text">
                  {t("header.chooseCurrency")}
                </p>
              </div>
              <img
                onClick={() => {
                  props.setShowPopup(false);
                  props.setPopupContent(null);
                  setNewSearchContent(null);
                  props.setPopupContentPosition("center");
                  if (props.setFavouriteClicked) {
                    props.setFavouriteClicked(false);
                  }
                }}
                className="add-funds-popup-close-icon"
                alt="Close Icon"
                src={popupCloseIcon}
              />
            </div>
            <div className="add-funds-content-search">
              <img alt="Search Icon" src={searchIcon} />
              <input
                onInputCapture={() => {
                  selectedCurrency.isClicked = false;
                }}
                onInput={(e) => {
                  if (e.target.value === "") {
                    setNewSearchContent(null);
                  } else {
                    setNewSearchContent(
                      // eslint-disable-next-line array-callback-return
                      getSupportedCurrenciesData.filter((curr) => {
                        if (
                          curr.currencySymbol
                            .toLowerCase()
                            .includes(e.target.value.toLowerCase())
                        ) {
                          curr.searched = e.target.value.toLowerCase();
                          curr.nameArray = curr.currencySymbol.split("");
                          return curr;
                        }
                      }),
                    );
                  }
                  const previouslyActiveTag = document.getElementsByClassName(
                    "a-f-content-search-header-main-active",
                  );
                  if (previouslyActiveTag.length > 0) {
                    previouslyActiveTag[0].className =
                      "a-f-content-search-header-main";
                  }
                  handleChooseCurrencyButtonDisplay();
                }}
                className="add-funds-content-search-input"
                type="text"
                placeholder={t("placeholder.currencySearch")}
              />
            </div>

            <div className="add-funds-content-search-result">
              <div className="a-f-content-search-result-header">
                {getSupportedCurrenciesLoading && (
                  <p>{t("common.loading")}...</p>
                )}
                {!newSearchContent &&
                  getSupportedCurrenciesData
                    .filter(
                      (curr) =>
                        curr.currencySymbol &&
                        curr.officialCurrencySymbol &&
                        curr.currencyName,
                    )
                    .map((curr, idx) => (
                      <div
                        id={`crypto-curencies-${idx}`}
                        key={`crypto-curencies-${idx}`}
                        onClickCapture={() => {
                          curr["isClicked"] = true;
                          setSelectedCurrency(curr);
                        }}
                        onClick={(e) => {
                          const previouslyActiveTag =
                            document.getElementsByClassName(
                              "a-f-content-search-header-main-active",
                            );
                          if (previouslyActiveTag.length > 0) {
                            previouslyActiveTag[0].className =
                              "a-f-content-search-header-main";
                          }
                          const currentTag = document.getElementById(
                            `crypto-curencies-${idx}`,
                          );
                          currentTag.className =
                            "a-f-content-search-header-main-active";
                          handleChooseCurrencyButtonDisplay();
                        }}
                        className="a-f-content-search-header-main"
                      >
                        <div className="a-f-content-search-header-main-container">
                          <div className="a-f-content-search-header-main-content">
                            <div className="a-f-content-search-header-image">
                              <Avatar name={curr.currencySymbol} />
                            </div>
                            <div className="a-f-content-search-header-text-container">
                              <p className="a-f-content-search-header-text-header">
                                {curr.currencySymbol}
                              </p>
                              <p className="a-f-content-search-header-text-footer">
                                {curr.currencyName}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                {newSearchContent &&
                  newSearchContent.length > 0 &&
                  newSearchContent.map((curr, idx) => (
                    <div
                      id={`crypto-curencies-${idx}`}
                      key={`crypto-curencies-${idx}`}
                      onClickCapture={() => {
                        curr["isClicked"] = true;
                        setSelectedCurrency(curr);
                      }}
                      onClick={(e) => {
                        const previouslyActiveTag =
                          document.getElementsByClassName(
                            "a-f-content-search-header-main-active",
                          );
                        if (previouslyActiveTag.length > 0) {
                          previouslyActiveTag[0].className =
                            "a-f-content-search-header-main";
                        }
                        const currentTag = document.getElementById(
                          `crypto-curencies-${idx}`,
                        );
                        currentTag.className =
                          "a-f-content-search-header-main-active";
                        handleChooseCurrencyButtonDisplay();
                      }}
                      className="a-f-content-search-header-main"
                    >
                      <div className="a-f-content-search-header-main-container">
                        <div className="a-f-content-search-header-main-content">
                          <div className="a-f-content-search-header-image">
                            <Avatar name={curr.currencySymbol} />
                          </div>
                          <div className="a-f-content-search-header-text-container">
                            <p className="a-f-content-search-header-text-header">
                              {curr.nameArray?.length > 0 &&
                                curr.nameArray.map((nm, idx) => (
                                  <>
                                    {!curr.searched.includes(
                                      nm.toLowerCase(),
                                    ) && (
                                      <span
                                        key={idx}
                                        style={{
                                          color: "#B6B7C3",
                                        }}
                                      >
                                        {nm}
                                      </span>
                                    )}
                                    {curr.searched.includes(
                                      nm.toLowerCase(),
                                    ) && <span key={idx}>{nm}</span>}
                                  </>
                                ))}
                            </p>
                            <p className="a-f-content-search-header-text-footer">
                              {curr.currencyName}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        )}
        {showAllCurrencies && (
          <button
            id="choose-currency-popup-button"
            onClick={(e) => {
              if (
                e.target.className.includes("startup-button") &&
                e.target.className !== "startup-button"
              ) {
                e.target.className = "startup-button-click";
                setShowAllCurrencies(false);
                setNewSearchContent(null);
              } else {
                const buttonElement = document.getElementsByClassName(
                  "startup-button-active",
                );
                if (buttonElement.length > 0) {
                  buttonElement[0].className = "startup-button-click";
                  setShowAllCurrencies(false);
                  setNewSearchContent(null);
                }
              }
            }}
            className="startup-button"
          >
            <p className="st-button-text"> {t("common.proceed")}</p>
          </button>
        )}
        {!showAllCurrencies &&
          selectedCurrency.tokenAddress?.toLowerCase() ===
            ethers.constants.AddressZero.toLowerCase() &&
          props?.addFundsAction !== "add-funds" && (
            <img style={{ width: "100%" }} src={lidoBanner} alt="" />
          )}
        {!showAllCurrencies &&
          selectedCurrency.tokenAddress === "" &&
          Object.keys(custodyWalletDetails)?.length > 0 &&
          props?.addFundsAction ===
            "add-funds"(
              <img style={{ width: "100%" }} src={custodyBanner} alt="" />,
            )}

        {!showAllCurrencies &&
          selectedCurrency.tokenAddress === "" &&
          Object.keys(verifiedWalletDetails)?.length > 0 &&
          props?.addFundsAction === "add-funds" && (
            <img style={{ width: "100%" }} src={verifiedWalletBanner} alt="" />
          )}
        {!showAllCurrencies &&
          !selectedCurrency.isCrypto &&
          props?.addFundsAction !== "add-funds-others" &&
          props?.addFundsAction !== "add-funds-crypto" && (
            <button
              id="add-funds-popup-button"
              onClick={async (e) => {
                if (
                  e.target.className.includes("startup-button") &&
                  e.target.className !== "startup-button"
                ) {
                  e.target.className = "startup-button-click";
                  setNewSearchContent(null);
                  await authenticateKYCStatus(
                    chainId,
                    userAddress,
                    web3,
                    appKitModal,
                    props.setPopupContent,
                    props.setPopupContentPosition,
                    props.setShowPopup,
                    props.setCustomLoading,
                    props.setFavouriteClicked,
                    false,
                    setVerifiedWalletDetails,
                    verifiedWalletDetails,
                    props.generalDataProps,
                  ).then(async (res) => {
                    if (res) {
                      props.setPopupContentPosition("flex-end");
                      props.setPopupContent(
                        <PaymentMethods
                          setShowPopup={props.setShowPopup}
                          setPopupContent={props.setPopupContent}
                          setPopupContentPosition={
                            props.setPopupContentPosition
                          }
                          setFavouriteClicked={props.setFavouriteClicked}
                          selectedCurrency={{
                            symbol: selectedCurrency.officialCurrencySymbol,
                            amount: amount,
                            ...selectedCurrency,
                          }}
                          generalDataProps={props.generalDataProps}
                        />,
                      );
                    }
                  });
                } else {
                  const buttonElement = document.getElementsByClassName(
                    "startup-button-active",
                  );
                  if (buttonElement.length > 0) {
                    buttonElement[0].className = "startup-button-click";
                    setNewSearchContent(null);

                    await authenticateKYCStatus(
                      chainId,
                      userAddress,
                      web3,
                      appKitModal,
                      props.setPopupContent,
                      props.setPopupContentPosition,
                      props.setShowPopup,
                      props.setCustomLoading,
                      props.setFavouriteClicked,
                      false,
                      setVerifiedWalletDetails,
                      verifiedWalletDetails,
                      props.generalDataProps,
                    ).then(async (res) => {
                      if (res) {
                        props.setPopupContentPosition("flex-end");
                        props.setPopupContent(
                          <PaymentMethods
                            setShowPopup={props.setShowPopup}
                            setPopupContent={props.setPopupContent}
                            setPopupContentPosition={
                              props.setPopupContentPosition
                            }
                            setFavouriteClicked={props.setFavouriteClicked}
                            selectedCurrency={{
                              symbol: selectedCurrency.officialCurrencySymbol,
                              amount: amount,
                              ...selectedCurrency,
                            }}
                            generalDataProps={props.generalDataProps}
                          />,
                        );
                      }
                    });
                  }
                }
              }}
              className="startup-button"
            >
              <p className="add-funds-popup-a-f-button-text">
                {t("addFunds.addFundsToWallet")}
              </p>
            </button>
          )}

        {!showAllCurrencies &&
          selectedCurrency.isCrypto &&
          props?.addFundsAction !== "add-funds-others" &&
          props?.addFundsAction !== "add-funds-crypto" && (
            <React.Fragment>
              {!selectedCurrency.isCryptoFiat &&
                props?.addFundsAction !== "add-funds" && (
                  <button
                    id="add-funds-popup-button"
                    onClick={async (e) => {
                      if (
                        e.target.className.includes("startup-button") &&
                        e.target.className !== "startup-button"
                      ) {
                        e.target.className = "startup-button-click";
                        await handleProvideLiquidity();
                      } else {
                        const buttonElement = document.getElementsByClassName(
                          "startup-button-active",
                        );
                        if (buttonElement.length > 0) {
                          buttonElement[0].className = "startup-button-click";
                          await handleProvideLiquidity();
                        }
                      }
                    }}
                    className="startup-button"
                  >
                    {!selectedCurrency.tokenAddress ? (
                      <p className="add-funds-popup-a-f-button-text">
                        {t("header.stakeFunds")}
                      </p>
                    ) : selectedCurrency.tokenAddress?.toLowerCase() !==
                      ethers.constants.AddressZero?.toLowerCase() ? (
                      <p className="add-funds-popup-a-f-button-text">
                        {t("addFunds.provideLiquidity")}
                      </p>
                    ) : (
                      <p className="add-funds-popup-a-f-button-text">
                        {t("header.stakeFunds")}
                      </p>
                    )}
                  </button>
                )}

              {!selectedCurrency.isCryptoFiat &&
                props?.addFundsAction === "add-funds" && (
                  <button
                    id="add-funds-popup-button"
                    onClick={async (e) => {
                      if (
                        e.target.className.includes("startup-button") &&
                        e.target.className !== "startup-button"
                      ) {
                        e.target.className = "startup-button-click";
                        setNewSearchContent(null);

                        await authenticateKYCStatus(
                          chainId,
                          userAddress,
                          web3,
                          appKitModal,
                          props.setPopupContent,
                          props.setPopupContentPosition,
                          props.setShowPopup,
                          props.setCustomLoading,
                          props.setFavouriteClicked,
                          false,
                          setVerifiedWalletDetails,
                          verifiedWalletDetails,
                          props.generalDataProps,
                        ).then(async (res) => {
                          if (res) {
                            props.setPopupContentPosition("flex-end");
                            props.setPopupContent(
                              <PaymentMethods
                                setShowPopup={props.setShowPopup}
                                setPopupContent={props.setPopupContent}
                                setPopupContentPosition={
                                  props.setPopupContentPosition
                                }
                                setFavouriteClicked={props.setFavouriteClicked}
                                selectedCurrency={{
                                  symbol:
                                    selectedCurrency.officialCurrencySymbol,
                                  amount: amount,
                                  ...selectedCurrency,
                                }}
                                linkedBankIds={linkedBankIds}
                                generalDataProps={props.generalDataProps}
                                bankList={bankList}
                                amountInPence={amount * 100}
                                amount={amount}
                              />,
                            );
                          }
                        });
                      } else {
                        const buttonElement = document.getElementsByClassName(
                          "startup-button-active",
                        );
                        if (buttonElement.length > 0) {
                          buttonElement[0].className = "startup-button-click";
                          setNewSearchContent(null);
                          await authenticateKYCStatus(
                            chainId,
                            userAddress,
                            web3,
                            appKitModal,
                            props.setPopupContent,
                            props.setPopupContentPosition,
                            props.setShowPopup,
                            props.setCustomLoading,
                            props.setFavouriteClicked,
                            false,
                            setVerifiedWalletDetails,
                            verifiedWalletDetails,
                            props.generalDataProps,
                          ).then(async (res) => {
                            if (res) {
                              props.setPopupContentPosition("flex-end");
                              props.setPopupContent(
                                <PaymentMethods
                                  setShowPopup={props.setShowPopup}
                                  setPopupContent={props.setPopupContent}
                                  setPopupContentPosition={
                                    props.setPopupContentPosition
                                  }
                                  setFavouriteClicked={
                                    props.setFavouriteClicked
                                  }
                                  selectedCurrency={{
                                    symbol:
                                      selectedCurrency.officialCurrencySymbol,
                                    amount: amount,
                                    ...selectedCurrency,
                                  }}
                                  linkedBankIds={linkedBankIds}
                                  generalDataProps={props.generalDataProps}
                                  bankList={bankList}
                                  amountInPence={amount * 100}
                                  amount={amount}
                                />,
                              );
                            }
                          });
                        }
                      }
                    }}
                    className="startup-button"
                  >
                    <p className="add-funds-popup-a-f-button-text">
                      {t("addFunds.addFundsToWallet")}
                    </p>
                  </button>
                )}
              {selectedCurrency.isCryptoFiat &&
                props?.addFundsAction === "add-funds" && (
                  <button
                    id="add-funds-popup-button"
                    onClick={async (e) => {
                      if (
                        e.target.className.includes("startup-button") &&
                        e.target.className !== "startup-button"
                      ) {
                        e.target.className = "startup-button-click";
                        setNewSearchContent(null);
                        await authenticateKYCStatus(
                          chainId,
                          userAddress,
                          web3,
                          appKitModal,
                          props.setPopupContent,
                          props.setPopupContentPosition,
                          props.setShowPopup,
                          props.setCustomLoading,
                          props.setFavouriteClicked,
                          false,
                          setVerifiedWalletDetails,
                          verifiedWalletDetails,
                          props.generalDataProps,
                        ).then(async (res) => {
                          if (res) {
                            props.setPopupContentPosition("flex-end");
                            props.setPopupContent(
                              <PaymentMethods
                                setShowPopup={props.setShowPopup}
                                setPopupContent={props.setPopupContent}
                                setPopupContentPosition={
                                  props.setPopupContentPosition
                                }
                                customLoading={props.customLoading}
                                setCustomLoading={props.setCustomLoading}
                                setFavouriteClicked={props.setFavouriteClicked}
                                selectedCurrency={{
                                  symbol:
                                    selectedCurrency.officialCurrencySymbol,
                                  amount: amount,
                                  ...selectedCurrency,
                                }}
                                linkedBankIds={linkedBankIds}
                                generalDataProps={props.generalDataProps}
                                bankList={bankList}
                                amountInPence={amount * 100}
                                amount={amount}
                                showCryptoPayment={true}
                              />,
                            );
                          }
                        });
                      } else {
                        const buttonElement = document.getElementsByClassName(
                          "startup-button-active",
                        );
                        if (buttonElement.length > 0) {
                          buttonElement[0].className = "startup-button-click";
                          setNewSearchContent(null);

                          await authenticateKYCStatus(
                            chainId,
                            userAddress,
                            web3,
                            appKitModal,
                            props.setPopupContent,
                            props.setPopupContentPosition,
                            props.setShowPopup,
                            props.setCustomLoading,
                            props.setFavouriteClicked,
                            false,
                            setVerifiedWalletDetails,
                            verifiedWalletDetails,
                            props.generalDataProps,
                          ).then(async (res) => {
                            if (res) {
                              props.setPopupContentPosition("flex-end");
                              props.setPopupContent(
                                <PaymentMethods
                                  setShowPopup={props.setShowPopup}
                                  setPopupContent={props.setPopupContent}
                                  setPopupContentPosition={
                                    props.setPopupContentPosition
                                  }
                                  customLoading={props.customLoading}
                                  setCustomLoading={props.setCustomLoading}
                                  setFavouriteClicked={
                                    props.setFavouriteClicked
                                  }
                                  selectedCurrency={{
                                    symbol:
                                      selectedCurrency.officialCurrencySymbol,
                                    amount: amount,
                                    ...selectedCurrency,
                                  }}
                                  linkedBankIds={linkedBankIds}
                                  generalDataProps={props.generalDataProps}
                                  bankList={bankList}
                                  amountInPence={amount * 100}
                                  amount={amount}
                                  showCryptoPayment={true}
                                />,
                              );
                            }
                          });
                        }
                      }
                    }}
                    className="startup-button"
                  >
                    <p className="add-funds-popup-a-f-button-text">
                      {t("addFunds.addFundsToWallet")}
                    </p>
                  </button>
                )}
              {selectedCurrency.isCryptoFiat &&
                props?.addFundsAction !== "add-funds" && (
                  <button
                    id="add-funds-popup-button"
                    onClick={async (e) => {
                      if (
                        e.target.className.includes("startup-button") &&
                        e.target.className !== "startup-button"
                      ) {
                        e.target.className = "startup-button-click";
                        await handleProvideLiquidity();
                      } else {
                        const buttonElement = document.getElementsByClassName(
                          "startup-button-active",
                        );
                        if (buttonElement.length > 0) {
                          buttonElement[0].className = "startup-button-click";
                          await handleProvideLiquidity();
                        }
                      }
                    }}
                    className="startup-button"
                  >
                    <p className="add-funds-popup-a-f-button-text">
                      {t("addFunds.provideLiquidity")}
                    </p>
                  </button>
                )}
            </React.Fragment>
          )}

        {!showAllCurrencies && props?.addFundsAction === "add-funds-others" && (
          <button
            onClick={async () => {
              if (Number(amount) <= 0) {
                errorToast(
                  "Invalid amount",
                  "Amount to top up must be greater than Zero(0).",
                );
                return;
              }

              setNewSearchContent(null);

              await authenticateKYCStatus(
                chainId,
                userAddress,
                web3,
                appKitModal,
                props.setPopupContent,
                props.setPopupContentPosition,
                props.setShowPopup,
                props.setCustomLoading,
                props.setFavouriteClicked,
                false,
                setVerifiedWalletDetails,
                verifiedWalletDetails,
                props.generalDataProps,
              ).then(async (res) => {
                if (res) {
                  props.setPopupContentPosition("flex-end");
                  props.setPopupContent(
                    <PaymentMethods
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      setFavouriteClicked={props.setFavouriteClicked}
                      selectedCurrency={{
                        symbol: props.accountCurrency,
                        amount: amount,
                        tokenName: "VCUSD",
                        accountNumber: props?.accountNumber,
                        tokenAddress: props?.accountNumber,
                      }}
                      linkedBankIds={linkedBankIds}
                      generalDataProps={props.generalDataProps}
                      bankList={bankList}
                      amountInPence={amount * 100}
                      amount={amount}
                      addFundsAction="add-funds-others"
                    />,
                  );
                }
              });
            }}
            className="startup-button-active"
          >
            <p className="add-funds-popup-a-f-button-text">Top Up</p>
          </button>
        )}

        {!showAllCurrencies &&
          props?.addFundsAction === "add-funds-crypto" &&
          props.accountAddress?.length > 0 && (
            <button
              onClick={async () => {
                if (Number(amount) <= 0) {
                  errorToast(
                    "Invalid amount",
                    "Amount to top up must be greater than Zero(0).",
                  );
                  return;
                }

                setNewSearchContent(null);
                props.setCustomLoading(true);

                await authenticateKYCStatus(
                  chainId,
                  userAddress,
                  web3,
                  appKitModal,
                  props.setPopupContent,
                  props.setPopupContentPosition,
                  props.setShowPopup,
                  props.setCustomLoading,
                  props.setFavouriteClicked,
                  false,
                  setVerifiedWalletDetails,
                  verifiedWalletDetails,
                  props.generalDataProps,
                ).then(async (res) => {
                  if (res) {
                    props.setCustomLoading(true);
                    const helpers = {
                      setSelectedCurrency,
                      setAmount,
                      setPopupContent: props.setPopupContent,
                      setPopupContentPosition: props.setPopupContentPosition,
                      setShowPopup: props.setShowPopup,
                      setFavouriteClicked: props.setFavouriteClicked,
                      customLoading: props.customLoading,
                      setCustomLoading: props.setCustomLoading,
                      generalDataProps: props.generalDataProps,
                      setCustomPopupPosition: setCustomPopupPosition,
                      setCustomPopupContent: setCustomPopupContent,
                      setShowCustomPopup: setShowCustomPopup,
                    };
                    const currencyContract = new ERC20(
                      signer,
                      props?.accountCurrencyAddress,
                    );
                    const amountFixed = ethers.utils.parseUnits(
                      amount?.toString(),
                      Number(props?.accountCurrencyDecimals),
                    );

                    const paymentToken = await authenticatePaymentToken(
                      chainId,
                      userAddress,
                      web3,
                      verifiedWalletDetails,
                      currencyContract,
                      "approve",
                      [props.accountAddress, amountFixed?.toString()],
                      helpers,
                      false,
                    );

                    await currencyContract
                      .approve(
                        props.accountAddress,
                        amountFixed?.toString(),
                        paymentToken?.address
                          ? {
                              paymentToken: paymentToken?.address,
                              apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                              rpcUrl: ChainConfig[chainId]?.rpcUrls[0],
                            }
                          : {},
                      )
                      .then(async (approveRes) => {
                        if (approveRes?.status === 0) {
                          successToast(
                            "Transaction successful",
                            "Cash contract approved.",
                          );
                          const cashTokenContract = new Cash(
                            signer,
                            props.accountAddress,
                          );
                          const paymentToken = await authenticatePaymentToken(
                            chainId,
                            userAddress,
                            web3,
                            verifiedWalletDetails,
                            cashTokenContract,
                            "requestIssue",
                            [
                              amountFixed?.toString(),
                              userAddress,
                              props.accountCurrency,
                            ],
                            helpers,
                            false,
                          );

                          await cashTokenContract
                            .requestIssue(
                              amountFixed?.toString(),
                              userAddress,
                              props.accountCurrency,
                              paymentToken?.address
                                ? {
                                    paymentToken: paymentToken?.address,
                                    apiKey:
                                      process.env.REACT_APP_BICONOMY_MEE_KEY,
                                    rpcUrl: ChainConfig[chainId]?.rpcUrls[0],
                                  }
                                : {},
                            )
                            .then((reqRes) => {
                              if (reqRes?.status === 0) {
                                props.setCustomLoading(false);
                                successToast(
                                  "Transaction successful",
                                  "Cash issued.",
                                );
                              } else {
                                props.setCustomLoading(false);
                                errorToast(
                                  "Transaction failed",
                                  "Error while requesting issue. Try again later",
                                );
                              }
                            });
                        } else {
                          props.setCustomLoading(false);
                          errorToast(
                            "Transaction failed",
                            "Error while apprvoing cash contract. Try again later",
                          );
                        }
                      });
                  }
                });
              }}
              className="startup-button-active"
            >
              <p className="add-funds-popup-a-f-button-text">
                {t("addFunds.addFundsToWalletCustom", {
                  issueTokenSymbol: props.accountNumber,
                })}
              </p>
            </button>
          )}
      </div>
    </React.Fragment>
  );
};

export default AddFunds;
